export default __webpack_public_path__ + "static/media/mini-farb-und-dini.6ede4cd5.png";